import { ReactElement } from 'react';

import { Flex } from '@bucketplace/design-system';

import { ContentsCardLayoutType } from 'brand/types';

import { CONTENTS_CARD_GAP } from '../constants';
import { ContentsCard } from './ContentsCard';

export function ContentsCardLayout({
  flexDirection = 'column',
  justify = 'flex-start',
  items,
  layoutIndex,
  childrenLayout,
}: ContentsCardLayoutType & { layoutIndex: number }): ReactElement {
  const renderLayout = (): ReactElement => {
    return (
      <Flex
        flex={1}
        gap={CONTENTS_CARD_GAP}
        justify={justify}
        direction={flexDirection}
      >
        { items.map((item) => (
          <ContentsCard
            key={item.id}
            item={item}
            logData={{
              section_id: 'CONTENTS',
              index: layoutIndex,
            }}
          />
        )) }
        { /* NOTE: 현재 한 케이스만 존재하여 반대의 경우는 고려하지 않음 */ }
        { childrenLayout && (
          <ContentsCardLayout
            {...childrenLayout}
            layoutIndex={layoutIndex}
          />
        ) }
      </Flex>
    );
  };

  return (
    <Flex>
      { renderLayout() }
    </Flex>
  );
}
